import { MediaAssetProviders } from '@/features/ai-video-creator/stores/productMediaSlice';
import { MediaAsset, MediaAssetType } from '@/types/media';
import { Product } from '@/types/product';

export type ImagesModalRecommendation = {
  stockMediaQuery?: string;
  videoScript?: string;
};

export enum MediaModalSectionName {
  stock = 'stock',
  product = 'product',
  upload = 'upload',
  playApp = 'playApp',
  instagram = 'instagram',
  googleDrive = 'googleDrive',
  dropbox = 'dropbox',
  aiImage = 'aiImage',
  aiBackground = 'aiBackground',
  aiVideo = 'aiVideo',
  tiktok = 'tiktok',
  aiTextToVideo = 'aiTextToVideo',
  personalAvatarImage = 'personalAvatarImage',
  bunuImages = 'bunuImages',
  bunuVideos = 'bunuVideos',
}

export const SECTIONS_WITHOUT_TOOLS = [
  MediaModalSectionName.stock,
  MediaModalSectionName.product,
  MediaModalSectionName.upload,
  MediaModalSectionName.playApp,
  MediaModalSectionName.instagram,
  MediaModalSectionName.tiktok,
  MediaModalSectionName.bunuImages,
  MediaModalSectionName.bunuVideos,
];

export const SECTIONS_WITHOUT_TOOLS_AND_ONLY_IMAGES = SECTIONS_WITHOUT_TOOLS.filter(
  (section) =>
    section !== MediaModalSectionName.playApp &&
    section !== MediaModalSectionName.tiktok &&
    section !== MediaModalSectionName.bunuVideos
);
export const SECTIONS_WITHOUT_TOOLS_AND_STOCK = SECTIONS_WITHOUT_TOOLS.filter(
  (section) => section !== MediaModalSectionName.stock
);

export const sectionToProviderMap = {
  [MediaModalSectionName.playApp]: MediaAssetProviders.playApp,
  [MediaModalSectionName.googleDrive]: MediaAssetProviders.googleDrive,
  [MediaModalSectionName.instagram]: MediaAssetProviders.instagram,
  [MediaModalSectionName.tiktok]: MediaAssetProviders.tiktok,
};

export type ImagesModalSectionProps = {
  section: MediaModalSectionName;
  recommendation?: ImagesModalRecommendation;
  selectedMedia: MediaAsset[];
  setSelectedMedia: React.Dispatch<React.SetStateAction<MediaAsset[]>>;
  setSelectedMediaAndClose: (media: MediaAsset[]) => void;
  product?: Product;
  preferredMediaAssetType?: MediaAssetType;
  setSelectedSection: (value: MediaModalSectionName) => void;
  isOnlyImages?: boolean;
  multiSelection?: boolean;
};
